import api from "axios";

export default function getCampaign(key = "") {
  return api
    .get(`/campaign/${key}`)
    .then((response) => response.data.payload)
    .catch((error) => `search ${error}`);
}
